import { useCallback, useEffect, useState } from 'react'
import { useSyncContext } from '@/core/offline/contexts/SyncContext'

export function useConflictResolver() {
  const { conflicts, getAllConflicts, resolveConflict: resolveConflictCtx } = useSyncContext()
  const [loading, setLoading] = useState(true)

  const loadConflicts = useCallback(async () => {
    try {
      await getAllConflicts()
    } catch (error) {
      console.error('Failed to load conflicts:', error)
    } finally {
      setLoading(false)
    }
  }, [getAllConflicts])

  const resolveConflict = useCallback(
    async (conflictId: string, resolution: 'local' | 'remote' | 'merge', mergeData?: any) => {
      try {
        const syncResolution = resolution === 'local' ? 'use_local' : resolution === 'remote' ? 'use_remote' : 'merge'
        await resolveConflictCtx(conflictId, syncResolution)
      } catch (error) {
        console.error('Failed to resolve conflict:', error)
      }
    },
    [resolveConflictCtx]
  )

  const resolvePatientDuplicate = useCallback(
    async (conflictId: string, selectedPatientId: string) => {
      try {
        await resolveConflictCtx(conflictId, 'use_remote')
      } catch (error) {
        console.error('Failed to resolve patient duplicate:', error)
      }
    },
    [resolveConflictCtx]
  )

  useEffect(() => {
    loadConflicts()
  }, [loadConflicts])

  return {
    conflicts,
    loading,
    resolveConflict,
    resolvePatientDuplicate,
  }
}
